import "./device-iphone.css";

/**
 * An iPhone, drawn in CSS, with whatever you pass it on the glass.
 *
 * Deliberately content-agnostic: it takes children rather than a slug, so the
 * same frame holds a screenshot, a cross-faded stack of six of them, or a
 * live-rendered layer that animates. See `device-iphone.css` for where the
 * proportions come from.
 *
 * `buttons` exists because the side rails are drawn outside the frame's own
 * bounds. In a tight grid that half-percent of overhang is the difference
 * between tiles that line up and tiles that nearly do.
 */
export default function DeviceIphone({
  children,
  className = "",
  plain = false,
  buttons = true,
  glare = true,
  island = true,
  ...rest
}) {
  return (
    <div
      className={`iphone${plain ? " iphone--plain" : ""} ${className}`.trim()}
      {...rest}
    >
      {/*
       * Outside the frame, not inside it. The frame carries a clip-path, and
       * clip-path clips descendants — so buttons nested in it were trimmed off
       * by the frame's own silhouette and never drew.
       */}
      {buttons && (
        <>
          <span className="iphone__btn iphone__btn--left iphone__btn--action" />
          <span className="iphone__btn iphone__btn--left iphone__btn--volume-up" />
          <span className="iphone__btn iphone__btn--left iphone__btn--volume-down" />
          <span className="iphone__btn iphone__btn--right iphone__btn--side" />
        </>
      )}

      <div className="iphone__frame">
        <div className="iphone__bezel">
          {/*
           * The island and the glare live inside the screen box, not beside
           * it. Their dimensions are percentages of the display — 125 x 36pt
           * of 440 x 956 — and as siblings of the screen they resolved against
           * the bezel's padding box instead, which is wider.
           */}
          <div className="iphone__screen">
            {children}
            {island && <span className="iphone__island" aria-hidden="true" />}
            {glare && <span className="iphone__glare" aria-hidden="true" />}
          </div>
        </div>
      </div>
    </div>
  );
}
